import React from 'react';

export const TenantPortalContext = React.createContext(undefined);

export function useTenantPortalProfile() {
  const ctx = React.useContext(TenantPortalContext);
  if (ctx === undefined) {
    throw new Error('useTenantPortalProfile must be used within TenantPortalLayout');
  }
  return ctx;
}

/** `properties.price_per_month` from admin — same £ style as public listings. */
export function formatListingPricePerMonth(pricePerMonth) {
  const n = Number(pricePerMonth);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `£${n.toLocaleString()} / month`;
}
